import { startCase } from 'lodash';

export const getDisplayValue = (value: string, stripPrefix?: string) => {
  if (stripPrefix) {
    value = value.replace(new RegExp(`^(${stripPrefix})`), '');
  }

  return startCase(value);
};
